import * as yup from "yup";
import { DayOfWeek, ThermostatAction, ThermostatSettingType } from "../generated/graphqlTypes";
export var ThermostatSettingSchema;
(function (ThermostatSettingSchema) {
    ThermostatSettingSchema.Types = [ThermostatSettingType.Hold, ThermostatSettingType.Scheduled];
    ThermostatSettingSchema.DaysOfWeek = [
        DayOfWeek.Monday,
        DayOfWeek.Tuesday,
        DayOfWeek.Wednesday,
        DayOfWeek.Thursday,
        DayOfWeek.Friday,
        DayOfWeek.Saturday,
        DayOfWeek.Sunday,
    ];
    ThermostatSettingSchema.Actions = [ThermostatAction.Heat, ThermostatAction.Cool, ThermostatAction.Circulate];
    ThermostatSettingSchema.SetPointRange = { min: 16, max: 40 };
    ThermostatSettingSchema.Schema = yup.object().shape({
        type: yup
            .string()
            .required()
            .oneOf(ThermostatSettingSchema.Types),
        // For Hold settings
        holdUntil: yup
            .date()
            .when("type", { is: ThermostatSettingType.Hold, then: yup.date().required() }),
        // For Scheduled settings
        daysOfWeek: yup
            .array()
            .of(yup.string().oneOf(ThermostatSettingSchema.DaysOfWeek))
            .when("type", {
            is: ThermostatSettingType.Scheduled,
            then: yup
                .array()
                .required()
                .min(1)
                .max(7),
            otherwise: yup.array().max(0),
        }),
        atMinutesSinceMidnight: yup.number().when("type", {
            is: ThermostatSettingType.Scheduled,
            then: yup
                .number()
                .required()
                .min(0)
                .lessThan(24 * 60),
            otherwise: yup.number().nullable(),
        }),
        // For all types
        allowedActions: yup.array().of(yup.string().oneOf(ThermostatSettingSchema.Actions)),
        setPointHeat: yup
            .number()
            .required()
            .min(ThermostatSettingSchema.SetPointRange.min)
            .max(ThermostatSettingSchema.SetPointRange.max),
        setPointCool: yup
            .number()
            .required()
            .min(ThermostatSettingSchema.SetPointRange.min)
            .max(ThermostatSettingSchema.SetPointRange.max),
        setPointCirculateAbove: yup
            .number()
            .required()
            .min(ThermostatSettingSchema.SetPointRange.min)
            .max(ThermostatSettingSchema.SetPointRange.max),
        setPointCirculateBelow: yup
            .number()
            .required()
            .min(ThermostatSettingSchema.SetPointRange.min)
            .max(ThermostatSettingSchema.SetPointRange.max),
    });
})(ThermostatSettingSchema || (ThermostatSettingSchema = {}));
//# sourceMappingURL=ThermostatSettingSchema.js.map